import { useMemo } from 'react'
import { LanguageCodeEnum } from '@/constants/i18n'
import { useLanguage } from '@/hooks/use-language'
import { useTranslation } from '@/i18n'

/**
 * 语言切换组件
 * 支持中英文切换
 */
export const LanguageToggle = () => {
  const { currentLanguage, currentLanguageConfig, toggleLanguage } = useLanguage()
  const { t } = useTranslation()

  const languageIcon = useMemo(() => {
    if (currentLanguage === LanguageCodeEnum.Zh) {
      return (
        <svg className='h-5 w-5 text-gray-800 dark:text-gray-200' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129'
          />
        </svg>
      )
    }
    return (
      <svg className='h-5 w-5 text-gray-800 dark:text-gray-200' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9'
        />
      </svg>
    )
  }, [currentLanguage])

  return (
    <button
      type='button'
      onClick={toggleLanguage}
      className='inline-flex items-center justify-center rounded-md p-2 transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none'
      title={`${t('components:languageToggle.currentLanguage')}: ${currentLanguageConfig.nativeLabel}\n${t('components:languageToggle.switchLanguage')}`}
      aria-label={`${t('components:languageToggle.switchLanguage')}, ${t('components:languageToggle.currentLanguage')}: ${currentLanguageConfig.nativeLabel}`}
    >
      <span className='sr-only'>{t('components:languageToggle.switchLanguage')}</span>
      {languageIcon}
    </button>
  )
}
